import { getLogger } from "@expert/logging";
import { expertWorkspaceWebSocketEventBus } from "@expert/websocket";
import { useEffect } from "react";
import { type NeglectionState, useChatStore } from "@/sdk";
import { userCache } from "@/shared-utils";

const logger = getLogger({
    module: "useNeglectionEventListener",
    supportTeam: "messaging",
});

export interface NeglectionEventPayload {
    chatId: string;
    expertEmployeeId: string;
    durationSeconds?: number;
    startTime?: number;
    endTime?: number;
}

export const useNeglectionEventListener = () => {
    useEffect(() => {
        return expertWorkspaceWebSocketEventBus.on("ws_chat-neglection-event", (payload: NeglectionEventPayload) => {
            logger.info({ neglectionEventPayload: JSON.stringify(payload) }, "Neglection event received");

            const { chatId, expertEmployeeId, startTime, durationSeconds, endTime } = payload;

            if (expertEmployeeId !== userCache.employeeId) {
                logger.info(
                    { expertEmployeeId, userCacheEmployeeId: userCache.employeeId },
                    "Ignoring neglection event for different expert",
                );
                return;
            }

            const updateData: Partial<NeglectionState> = { endTime: endTime ? new Date(endTime) : undefined };

            if (startTime) {
                updateData.startTime = new Date(startTime);
            }
            if (durationSeconds) {
                updateData.durationSeconds = durationSeconds;
            }

            useChatStore.getState().updateChatNeglection(chatId, updateData);
        });
    }, []);
};
